import { AutogenLayoutHoursOfServiceTable } from "./autogen/AutogenLayoutHoursOfServiceTable";
import { DataSourceMode, Label, TableRowDisplayEvent, Textbox, ValidationResult } from "@mcleod/components";
import { DateUtil, ModelRow } from "@mcleod/core";

export class HoursOfServiceTable extends AutogenLayoutHoursOfServiceTable {
    public isCanadianHOS: boolean = false;

    tableDriverHoursOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;

        const labelLogDate = tableRow.findComponentById("labelLogDate") as Label;
        const logDate = modelRow.getDate("log_date");
        labelLogDate.text = `${DateUtil.formatDate(logDate)} - ${DateUtil.getDayOfWeek(logDate)}`;

        const textboxHours = tableRow.findComponentById("textboxHours") as Textbox;
        textboxHours.addlValidationCallback = (value: string, mode: DataSourceMode): ValidationResult => {
            if (mode === DataSourceMode.SEARCH) {
                return null;
            }
            if (parseFloat(value) > 24) {
                return {
                    caption: "Hours Worked",
                    component: textboxHours,
                    componentToFocus: textboxHours,
                    isValid: false,
                    validationMessage: "Hours for a day cannot be more than 24"
                };
            }
            if (parseFloat(value) < 0) {
                return {
                    caption: "Hours Worked",
                    component: textboxHours,
                    componentToFocus: textboxHours,
                    isValid: false,
                    validationMessage: "Hours cannot be negative"
                }
            }
        };
    }

    getRemainingHours(index: number): number {
        let sum = 0.0;
        if (index == 0) {
            sum = this.getRemainingHoursToday();
            if (sum != 0.0) {
                return sum;
            }
        }
        index = this.getStartingIndex(index);

        for (let i = index; i < this.tableDriverHours.allRows.length; ++i) {
            const data = this.tableDriverHours.allRows[i].data as ModelRow;
            if (data.getBoolean("is_reset_day", false)) {
                sum = 0.0
            }
            if (!data.isNull("hours")) {
                sum += data.getNumber("hours")
            }
        }
        return 70.0 - sum;
    }

    getRemainingHoursToday(): number {
        let value = 0.0;
        const date = DateUtil.justDate(new Date());

        for (let i = 0; i < this.tableDriverHours.allRows.length; i++) {
            const data = this.tableDriverHours.allRows[i].data as ModelRow;
            const logDate = DateUtil.justDate(data.getDate("log_date"));
            if (DateUtil.datesEqual(date, logDate)) {
                value = data.getNumber("remaining_hours", value);
                break;
            }
        }

        return value;
    }

    getStartingIndex(index: number) {
        if (this.isCanadianHOS) {
            return this.tableDriverHours.allRows.length - 7 + index;
        }
        return this.tableDriverHours.allRows.length - 8 + index;
    }

}
